// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-734d6ae9] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget-custom[data-v-734d6ae9] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
}
.widget-custom.full-width[data-v-734d6ae9] {
  width: var(--widget-full-width, 100%) !important;
  inset-inline-start: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);
  position: relative;
}
.widget-access[data-v-734d6ae9] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
  padding: calc(var(--default-grid-baseline, 4px) * 3);
}
.widget-default[data-v-734d6ae9] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-container);
  background-color: transparent;
  display: flex;
}
.widget-default--compact[data-v-734d6ae9] {
  flex-direction: column;
}
.widget-default--compact .widget-default--image[data-v-734d6ae9] {
  width: 100%;
  height: 150px;
}
.widget-default--compact .widget-default--details[data-v-734d6ae9] {
  width: 100%;
  padding-top: calc(var(--default-grid-baseline, 4px) * 2);
  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);
}
.widget-default--compact .widget-default--description[data-v-734d6ae9] {
  display: none;
}
.widget-default--image[data-v-734d6ae9] {
  width: 40%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.widget-default--name[data-v-734d6ae9] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
.widget-default--details[data-v-734d6ae9] {
  padding: calc(var(--default-grid-baseline, 4px) * 3);
  width: 60%;
}
.widget-default--details p[data-v-734d6ae9] {
  margin: 0;
  padding: 0;
}
.widget-default--description[data-v-734d6ae9] {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.widget-default--link[data-v-734d6ae9] {
  color: var(--color-text-maxcontrast);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.toggle-interactive[data-v-734d6ae9] {
  position: relative;
}
.toggle-interactive .toggle-interactive--button[data-v-734d6ae9] {
  position: absolute;
  bottom: var(--default-grid-baseline);
  inset-inline-end: var(--default-grid-baseline);
  z-index: 10000;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-93468058] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-10f6fc31] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.provider-list[data-v-10f6fc31] {
  width: 100%;
  min-height: 400px;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
}
.provider-list--select[data-v-10f6fc31] {
  width: 100%;
}
.provider-list--select .provider[data-v-10f6fc31] {
  display: flex;
  align-items: center;
  height: 28px;
  overflow: hidden;
}
.provider-list--select .provider .link-icon[data-v-10f6fc31] {
  margin-inline-end: 8px;
}
.provider-list--select .provider .provider-icon[data-v-10f6fc31] {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-inline-end: 8px;
  filter: var(--background-invert-if-dark);
}
.provider-list--select .provider .option-text[data-v-10f6fc31] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-3c1803b5] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.raw-link[data-v-3c1803b5] {
  width: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 16px 16px 16px;
}
.raw-link .input-wrapper[data-v-3c1803b5] {
  width: 100%;
}
.raw-link .reference-widget[data-v-3c1803b5] {
  display: flex;
}
.raw-link--empty-content .provider-icon[data-v-3c1803b5] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.raw-link--input[data-v-3c1803b5] {
  width: 99%;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-ff4bcbf3] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.result[data-v-ff4bcbf3] {
  display: flex;
  align-items: center;
  height: var(--default-clickable-area);
  overflow: hidden;
}
.result--icon-class[data-v-ff4bcbf3], .result--image[data-v-ff4bcbf3] {
  width: 40px;
  min-width: 40px;
  height: 40px;
  object-fit: contain;
}
.result--icon-class.rounded[data-v-ff4bcbf3], .result--image.rounded[data-v-ff4bcbf3] {
  border-radius: 50%;
}
.result--content[data-v-ff4bcbf3] {
  display: flex;
  flex-direction: column;
  padding-inline-start: 10px;
  overflow: hidden;
}
.result--content--name[data-v-ff4bcbf3], .result--content--subline[data-v-ff4bcbf3] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-05fef988] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.smart-picker-search[data-v-05fef988] {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px 16px;
}
.smart-picker-search.with-empty-content[data-v-05fef988] {
  min-height: 400px;
}
.smart-picker-search .provider-icon[data-v-05fef988] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.smart-picker-search--select[data-v-05fef988] {
  width: 100%;
}
.smart-picker-search--select .search-result[data-v-05fef988] {
  width: 100%;
}
.smart-picker-search--select .group-name-icon[data-v-05fef988],
.smart-picker-search--select .option-simple-icon[data-v-05fef988] {
  width: 20px;
  height: 20px;
  margin: 0 20px 0 10px;
}
.smart-picker-search--select .custom-option[data-v-05fef988] {
  height: var(--default-clickable-area);
  display: flex;
  align-items: center;
  overflow: hidden;
}
.smart-picker-search--select .option-text[data-v-05fef988] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-98624f25] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker[data-v-98624f25] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}
.reference-picker .custom-element-wrapper[data-v-98624f25] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}
.reference-picker .custom-element-wrapper .custom-element[data-v-98624f25] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-13d8f21e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker-modal[data-v-13d8f21e] .modal-container {
  display: flex !important;
}
.reference-picker-modal--content[data-v-13d8f21e] {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}
.reference-picker-modal--content .close-button[data-v-13d8f21e],
.reference-picker-modal--content .back-button[data-v-13d8f21e] {
  position: absolute;
  top: 4px;
}
.reference-picker-modal--content .back-button[data-v-13d8f21e] {
  inset-inline-start: 4px;
}
.reference-picker-modal--content .close-button[data-v-13d8f21e] {
  inset-inline-end: 4px;
}
.reference-picker-modal--content > h2[data-v-13d8f21e] {
  display: flex;
  margin: 12px 0 20px 0;
}
.reference-picker-modal--content > h2 .icon[data-v-13d8f21e] {
  margin-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/referencePickerModal-DrvqNTIf.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gDAAgD;EAChD,0EAA0E;EAC1E,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,8CAA8C;EAC9C,cAAc;AAChB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-734d6ae9] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget-custom[data-v-734d6ae9] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n}\n.widget-custom.full-width[data-v-734d6ae9] {\n  width: var(--widget-full-width, 100%) !important;\n  inset-inline-start: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);\n  position: relative;\n}\n.widget-access[data-v-734d6ae9] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n}\n.widget-default[data-v-734d6ae9] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-container);\n  background-color: transparent;\n  display: flex;\n}\n.widget-default--compact[data-v-734d6ae9] {\n  flex-direction: column;\n}\n.widget-default--compact .widget-default--image[data-v-734d6ae9] {\n  width: 100%;\n  height: 150px;\n}\n.widget-default--compact .widget-default--details[data-v-734d6ae9] {\n  width: 100%;\n  padding-top: calc(var(--default-grid-baseline, 4px) * 2);\n  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);\n}\n.widget-default--compact .widget-default--description[data-v-734d6ae9] {\n  display: none;\n}\n.widget-default--image[data-v-734d6ae9] {\n  width: 40%;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.widget-default--name[data-v-734d6ae9] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: bold;\n}\n.widget-default--details[data-v-734d6ae9] {\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n  width: 60%;\n}\n.widget-default--details p[data-v-734d6ae9] {\n  margin: 0;\n  padding: 0;\n}\n.widget-default--description[data-v-734d6ae9] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.widget-default--link[data-v-734d6ae9] {\n  color: var(--color-text-maxcontrast);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.toggle-interactive[data-v-734d6ae9] {\n  position: relative;\n}\n.toggle-interactive .toggle-interactive--button[data-v-734d6ae9] {\n  position: absolute;\n  bottom: var(--default-grid-baseline);\n  inset-inline-end: var(--default-grid-baseline);\n  z-index: 10000;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-93468058] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-10f6fc31] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.provider-list[data-v-10f6fc31] {\n  width: 100%;\n  min-height: 400px;\n  padding: 0 16px 16px 16px;\n  display: flex;\n  flex-direction: column;\n}\n.provider-list--select[data-v-10f6fc31] {\n  width: 100%;\n}\n.provider-list--select .provider[data-v-10f6fc31] {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  overflow: hidden;\n}\n.provider-list--select .provider .link-icon[data-v-10f6fc31] {\n  margin-inline-end: 8px;\n}\n.provider-list--select .provider .provider-icon[data-v-10f6fc31] {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  margin-inline-end: 8px;\n  filter: var(--background-invert-if-dark);\n}\n.provider-list--select .provider .option-text[data-v-10f6fc31] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-3c1803b5] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.raw-link[data-v-3c1803b5] {\n  width: 100%;\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0 16px 16px 16px;\n}\n.raw-link .input-wrapper[data-v-3c1803b5] {\n  width: 100%;\n}\n.raw-link .reference-widget[data-v-3c1803b5] {\n  display: flex;\n}\n.raw-link--empty-content .provider-icon[data-v-3c1803b5] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.raw-link--input[data-v-3c1803b5] {\n  width: 99%;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-ff4bcbf3] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.result[data-v-ff4bcbf3] {\n  display: flex;\n  align-items: center;\n  height: var(--default-clickable-area);\n  overflow: hidden;\n}\n.result--icon-class[data-v-ff4bcbf3], .result--image[data-v-ff4bcbf3] {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n.result--icon-class.rounded[data-v-ff4bcbf3], .result--image.rounded[data-v-ff4bcbf3] {\n  border-radius: 50%;\n}\n.result--content[data-v-ff4bcbf3] {\n  display: flex;\n  flex-direction: column;\n  padding-inline-start: 10px;\n  overflow: hidden;\n}\n.result--content--name[data-v-ff4bcbf3], .result--content--subline[data-v-ff4bcbf3] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-05fef988] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.smart-picker-search[data-v-05fef988] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px 16px 16px;\n}\n.smart-picker-search.with-empty-content[data-v-05fef988] {\n  min-height: 400px;\n}\n.smart-picker-search .provider-icon[data-v-05fef988] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.smart-picker-search--select[data-v-05fef988] {\n  width: 100%;\n}\n.smart-picker-search--select .search-result[data-v-05fef988] {\n  width: 100%;\n}\n.smart-picker-search--select .group-name-icon[data-v-05fef988],\n.smart-picker-search--select .option-simple-icon[data-v-05fef988] {\n  width: 20px;\n  height: 20px;\n  margin: 0 20px 0 10px;\n}\n.smart-picker-search--select .custom-option[data-v-05fef988] {\n  height: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.smart-picker-search--select .option-text[data-v-05fef988] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-98624f25] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker[data-v-98624f25] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}\n.reference-picker .custom-element-wrapper[data-v-98624f25] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}\n.reference-picker .custom-element-wrapper .custom-element[data-v-98624f25] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-13d8f21e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker-modal[data-v-13d8f21e] .modal-container {\n  display: flex !important;\n}\n.reference-picker-modal--content[data-v-13d8f21e] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n}\n.reference-picker-modal--content .close-button[data-v-13d8f21e],\n.reference-picker-modal--content .back-button[data-v-13d8f21e] {\n  position: absolute;\n  top: 4px;\n}\n.reference-picker-modal--content .back-button[data-v-13d8f21e] {\n  inset-inline-start: 4px;\n}\n.reference-picker-modal--content .close-button[data-v-13d8f21e] {\n  inset-inline-end: 4px;\n}\n.reference-picker-modal--content > h2[data-v-13d8f21e] {\n  display: flex;\n  margin: 12px 0 20px 0;\n}\n.reference-picker-modal--content > h2 .icon[data-v-13d8f21e] {\n  margin-inline-end: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
